import { Link } from "react-router-dom"
import React from "react"

function Footer() {
	function track(label: string) {
		try {
			// eslint-disable-next-line
			let dataLayer = window["dataLayer"] || []
			dataLayer.push({ event: "footer", link: label })
		} catch (e) {}
	}

	return (
		<footer className="relative mt-12  mb-12  items-center bg-white lg:z-[300]">
			<section className="grid w-full items-end  bg-white bg-cover bg-bottom lg:mt-0">
				<div className="flex flex-col items-center justify-center py-4 font-Alpro  text-[12px] md:mt-8 lg:mt-0 lg:flex-row lg:text-[16px]">
					<Link to={"/teilnahmebedingungen"} className=" text-[24px] text-blue md:text-[32px] lg:mr-12" onClick={() => track("Teilnahmebedingungen")}>
						Teilnahmebedingungen
					</Link>
					<Link to={"/faq"} className=" text-[24px] text-blue md:text-[32px] lg:mr-12" onClick={() => track("Datenschutz")}>
						FAQ
					</Link>
					<Link to={"/impressum"} className=" text-[24px] text-blue md:text-[32px] lg:mr-12" onClick={() => track("Impressum")}>
						Impressum
					</Link>
				</div>
			</section>
		</footer>
	)
}

export default Footer
